import {SET_WAITING_REQUESTS} from './swConstants'
import dbSw from '../../serviceWorkerDb'

function setWaitingRequestsAction(waitingRequests){
    return {
        waitingRequests,
        type: SET_WAITING_REQUESTS,
    }
}

export function actualizeWaitingRequests(){
    return async (dispatch) => {

        let swLaunched = false;

        dbSw.tables.forEach(function (table) {
            if(table.name === "requests")
                swLaunched = true;
        });

        if(swLaunched)
            dbSw.requests.toArray().then((requests) => dispatch(setWaitingRequestsAction(requests)))
    }
}
